import { agentOfficeSetupConstants } from "./agentOfficeSetup.constants";
import { agentOfficeSetupService } from "../../../services";

export const agentOfficeSetupActions = {
	getAgentOfficesList,
	getPrimaryContacts,
	addAgentOfficeForm,
	getEditAgentOfficeForm,
	editAgentOfficeForm,
	getAgents,
	getMerchantsList,
	getNotificationTemplates,
	getESignAccounts,
	saveNotificationMessageTemplatesForm,
	getCheckOfficeName,
	getFeeTemplates,
	reorderFeeTemplates,
	copyFeeTemplate,
	changeFeeTemplateStatus,
	deleteFeeTemplate,
	saveTsysAccount,
	saveRiservAccount,
	getTsysCredentials,
	getFDCredentials,
	getMonthlyFeeTemplates,
	changeMonthlyFeeTemplateStatus,
};

function getAgentOfficesList({ page, sort, filtersApplied }) {
	return dispatch => {
		dispatch(request(page, sort));

		return agentOfficeSetupService
			.getAgentOfficesList({ page, sort, filtersApplied })
			.then(
				agentOffices => {
					dispatch(success(agentOffices));
					return Promise.resolve();
				},
				error => {
					dispatch(failure(error));
					return Promise.reject();
				},
			);
	};

	function request(page, sort) {
		return {
			type: agentOfficeSetupConstants.GET_AGENT_OFFICES_REQUEST,
			page,
			sort,
		};
	}

	function success(agentOffice) {
		return {
			type: agentOfficeSetupConstants.GET_AGENT_OFFICES_SUCCESS,
			agentOffice,
		};
	}

	function failure(error) {
		return {
			type: agentOfficeSetupConstants.GET_AGENT_OFFICES_FAILURE,
			error,
		};
	}
}

function getPrimaryContacts(companyId) {
	return dispatch => {
		return agentOfficeSetupService.getPrimaryContacts(companyId).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};

	function success(primaryContact) {
		return {
			type: agentOfficeSetupConstants.GET_PRIMARY_CONTACT_SUCCESS,
			primaryContact,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.GET_PRIMARY_CONTACT_ERROR,
			error,
		};
	}
}

function addAgentOfficeForm(model) {
	return dispatch => {
		return agentOfficeSetupService.addAgentOfficeForm(model).then(
			result => {
				dispatch(success(result));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function success(addAgentForm) {
		return {
			type: agentOfficeSetupConstants.ADD_AGENT_FORM_SUCCESS,
			addAgentForm,
		};
	}
	function failure(error) {
		return { type: agentOfficeSetupConstants.ADD_AGENT_FORM_ERROR, error };
	}
}

function editAgentOfficeForm(companyId, model) {
	return dispatch => {
		return agentOfficeSetupService
			.editAgentOfficeForm(companyId, model)
			.then(result => {
				dispatch(success(result));
				return Promise.resolve();
			});
	};

	function success() {
		return { type: agentOfficeSetupConstants.SAVE_EDIT_AGENT_FORM_SUCCESS };
	}
}

// Action for  Edit Agent Office Form

function getEditAgentOfficeForm(companyId) {
	return dispatch => {
		dispatch(request());
		return agentOfficeSetupService.getEditAgentOfficeForm(companyId).then(
			result => dispatch(success(result)),
			error => {
				dispatch(failure(error));
				return Promise.reject(failure(error));
			},
		);
	};

	function request() {
		return {
			type: agentOfficeSetupConstants.EDIT_AGENT_OFFICE_DOCUMENT_REQUEST,
		};
	}

	function success(editAgentOfficeForm) {
		return {
			type: agentOfficeSetupConstants.EDIT_AGENT_OFFICE_DOCUMENT_SUCCESS,
			editAgentOfficeForm,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.EDIT_AGENT_OFFICE_DOCUMENT_ERROR,
			error,
		};
	}
}

// Actions for Edit Agent Tab in Edit Agent Office

function getAgents(id) {
	return dispatch => {
		return agentOfficeSetupService.getAgents(id).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};

	function success(agents) {
		return { type: agentOfficeSetupConstants.GET_AGENTS_SUCCESS, agents };
	}
	function failure(error) {
		return { type: agentOfficeSetupConstants.GET_AGENTS_ERROR, error };
	}
}

function getMerchantsList(id) {
	return dispatch => {
		return agentOfficeSetupService.getMerchantsList(id).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};

	function success(result) {
		return {
			type: agentOfficeSetupConstants.GET_MERCHANT_LIST_SUCCESS,
			merchantList: result.merchants,
			isAriseSyncEnabled: result.isAriseSyncEnabled,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.GET_MERCHANT_LIST_ERROR,
			error,
		};
	}
}

function getNotificationTemplates(id) {
	return dispatch => {
		return agentOfficeSetupService.getNotificationTemplates(id).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};

	function success(notificationTemplates) {
		return {
			type: agentOfficeSetupConstants.GET_NOTIFICATION_TEMPLATES_SUCCESS,
			notificationTemplates,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.GET_NOTIFICATION_TEMPLATES_ERROR,
			error,
		};
	}
}

function getESignAccounts() {
	return dispatch => {
		return agentOfficeSetupService.getESignAccounts().then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};

	function success(eSignAccounts) {
		return {
			type: agentOfficeSetupConstants.GET_E_SIGN_ACCOUNTS_SUCCESS,
			eSignAccounts,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.GET_E_SIGN_ACCOUNTS_ERROR,
			error,
		};
	}
}

function saveNotificationMessageTemplatesForm(id, model) {
	return dispatch => {
		return agentOfficeSetupService
			.saveNotificationMessageTemplatesForm(id, model)
			.then(
				result => {
					dispatch(success(result));
					return Promise.resolve();
				},
				error => {
					dispatch(failure(error));
					return Promise.reject();
				},
			);
	};

	function success() {
		return {
			type: agentOfficeSetupConstants.SAVE_NOTIFICATION_TEMPLATE_FORM_SUCCESS,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.SAVE_NOTIFICATION_TEMPLATE_FORM_ERROR,
			error,
		};
	}
}

function getCheckOfficeName(name) {
	return dispatch => {
		return agentOfficeSetupService.getCheckOfficeName(name).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};
	function success(name) {
		return {
			type: agentOfficeSetupConstants.GET_CHECK_OFFICE_NAME_SUCCESS,
			name,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.GET_CHECK_OFFICE_NAME_ERROR,
			error,
		};
	}
}

// Additional Fee Templates Tab

function getFeeTemplates(id, templatePage) {
	const isAdditionalFee = templatePage === "AdditionalFees";

	return dispatch => {
		dispatch(request());

		return agentOfficeSetupService.getFeeTemplates(id, templatePage).then(
			data => dispatch(success(data)),
			error => dispatch(failure(error)),
		);
	};

	function request() {
		return {
			type: isAdditionalFee
				? agentOfficeSetupConstants.GET_EDIT_ADDITIONAL_FEE_DOCUMENTS_REQUEST
				: agentOfficeSetupConstants.GET_FEE_TEMPLATES_REQUEST,
		};
	}

	function success(feeTemplates) {
		return {
			type: isAdditionalFee
				? agentOfficeSetupConstants.GET_EDIT_ADDITIONAL_FEE_DOCUMENTS_SUCCESS
				: agentOfficeSetupConstants.GET_FEE_TEMPLATES_SUCCESS,
			feeTemplates,
		};
	}
	function failure(error) {
		return {
			type: isAdditionalFee
				? agentOfficeSetupConstants.GET_EDIT_ADDITIONAL_FEE_DOCUMENTS_ERROR
				: agentOfficeSetupConstants.GET_FEE_TEMPLATES_ERROR,
			error,
		};
	}
}

function changeFeeTemplateStatus(
	companyId,
	templateId,
	active,
	isAdditionalFee,
) {
	return dispatch => {
		dispatch(request(templateId, active));
		return agentOfficeSetupService
			.changeFeeTemplateStatus(companyId, templateId, active)
			.then(
				data => {
					dispatch(success(data));
					return Promise.resolve(data);
				},
				error => {
					dispatch(failure(error, templateId, !active));
					return Promise.reject(error);
				},
			);
	};

	function request(templateId, active) {
		return {
			type: isAdditionalFee
				? agentOfficeSetupConstants.CHANGE_ADDITIONAL_FEE_TEMPLATE_STATUS_REQUEST
				: agentOfficeSetupConstants.CHANGE_FEE_TEMPLATE_STATUS_REQUEST,
			templateId,
			active,
		};
	}
	function success() {
		return {
			type: isAdditionalFee
				? agentOfficeSetupConstants.CHANGE_ADDITIONAL_FEE_TEMPLATE_STATUS_SUCCESS
				: agentOfficeSetupConstants.CHANGE_FEE_TEMPLATE_STATUS_SUCCESS,
		};
	}
	function failure(error, templateId, active) {
		return {
			type: isAdditionalFee
				? agentOfficeSetupConstants.CHANGE_ADDITIONAL_FEE_TEMPLATE_STATUS_ERROR
				: agentOfficeSetupConstants.CHANGE_FEE_TEMPLATE_STATUS_ERROR,
			error,
			templateId,
			active,
		};
	}
}

function copyFeeTemplate(companyId, templateId, name) {
	return dispatch => {
		return agentOfficeSetupService
			.copyFeeTemplate(companyId, templateId, name)
			.then(
				data => {
					dispatch(success(data));
					return Promise.resolve(data);
				},
				error => {
					dispatch(failure(error));
					return Promise.reject(error);
				},
			);
	};

	function success() {
		return {
			type: agentOfficeSetupConstants.COPY_FEE_TEMPLATE_SUCCESS,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.COPY_FEE_TEMPLATE_ERROR,
			error,
		};
	}
}

function reorderFeeTemplates(
	companyId,
	templateType,
	reorderedTemplates,
	orderedTemplates,
) {
	const model = {
		companyId,
		reorderedTemplates: reorderedTemplates.map((x, i) => ({
			id: x.id,
			order: i,
		})),
	};

	return dispatch => {
		dispatch(request(templateType, reorderedTemplates));

		return agentOfficeSetupService.reorderFeeTemplate(model).then(
			data => {
				dispatch(success(data));
				return Promise.resolve(data);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function request(templateType, reorderedTemplates) {
		return {
			type: agentOfficeSetupConstants.REODER_FEE_TEMPLATES_REQUEST,
			templateType,
			reorderedTemplates,
		};
	}

	function success() {
		return {
			type: agentOfficeSetupConstants.REODER_FEE_TEMPLATES_SUCCESS,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.REODER_FEE_TEMPLATES_ERROR,
			error,
			templateType,
			orderedTemplates,
		};
	}
}

function deleteFeeTemplate(companyId, templateId) {
	return dispatch => {
		dispatch(request());
		return agentOfficeSetupService
			.deleteFeeTemplate(companyId, templateId)
			.then(
				data => {
					dispatch(success(data));
					return Promise.resolve(data);
				},
				error => {
					dispatch(failure(error));
					return Promise.reject(error);
				},
			);
	};

	function request() {
		return {
			type: agentOfficeSetupConstants.DELETE_FEE_TEMPLATE_REQUEST,
		};
	}
	function success() {
		return {
			type: agentOfficeSetupConstants.DELETE_FEE_TEMPLATE_SUCCESS,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.DELETE_FEE_TEMPLATE_ERROR,
			error,
		};
	}
}

function saveTsysAccount(model) {
	return dispatch => {
		return agentOfficeSetupService.saveTsysAccount(model).then(
			result => {
				dispatch(success(result));
				return Promise.resolve();
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function success() {
		return { type: agentOfficeSetupConstants.SAVE_TSYS_ACCOCUNT_SUCCESS };
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.SAVE_TSYS_ACCOCUNT_ERROR,
			error,
		};
	}
}

function saveRiservAccount(model) {
	return dispatch => {
		return agentOfficeSetupService.saveRiservAccount(model).then(
			result => {
				dispatch(success(result));
				return Promise.resolve();
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function success() {
		return { type: agentOfficeSetupConstants.SAVE_RISERV_ACCOUNT_SUCCESS };
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.SAVE_RISERV_ACCOUNT_ERROR,
			error,
		};
	}
}

function getTsysCredentials(agentOfficeId) {
	return dispatch => {
		dispatch(request());
		return agentOfficeSetupService.getTsysCredentials(agentOfficeId).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};

	function request() {
		return {
			type: agentOfficeSetupConstants.GET_TSYS_CREDENTIALS_REQUEST,
		};
	}
	function success(tsysCredentials) {
		return {
			type: agentOfficeSetupConstants.GET_TSYS_CREDENTIALS_SUCCESS,
			tsysCredentials,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.GET_TSYS_CREDENTIALS_ERROR,
			error,
		};
	}
}

function getFDCredentials(agentOfficeId) {
	return dispatch => {
		dispatch(request());
		return agentOfficeSetupService.getFDCredentials(agentOfficeId).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};

	function request() {
		return {
			type: agentOfficeSetupConstants.GET_FD_CREDENTIALS_REQUEST,
		};
	}
	function success(ftCredentials) {
		return {
			type: agentOfficeSetupConstants.GET_FD_CREDENTIALS_SUCCESS,
			ftCredentials,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.GET_FD_CREDENTIALS_ERROR,
			error,
		};
	}
}

//Monthly Fee Templates Tab
function getMonthlyFeeTemplates(id) {
	return dispatch => {
		dispatch(request());

		return agentOfficeSetupService.getFeeTemplates(id, "MonthlyFees").then(
			data => dispatch(success(data)),
			error => dispatch(failure(error)),
		);
	};

	function request() {
		return {
			type: agentOfficeSetupConstants.GET_EDIT_MONTHLY_FEE_DOCUMENTS_REQUEST,
		};
	}

	function success(feeTemplates) {
		return {
			type: agentOfficeSetupConstants.GET_EDIT_MONTHLY_FEE_DOCUMENTS_SUCCESS,
			feeTemplates,
		};
	}
	function failure(error) {
		return {
			type: agentOfficeSetupConstants.GET_EDIT_MONTHLY_FEE_DOCUMENTS_ERROR,
			error,
		};
	}
}

function changeMonthlyFeeTemplateStatus(companyId, templateId, active) {
	return dispatch => {
		dispatch(request(templateId, active));
		return agentOfficeSetupService
			.changeFeeTemplateStatus(companyId, templateId, active)
			.then(
				data => {
					dispatch(success(data));
					return Promise.resolve(data);
				},
				error => {
					dispatch(failure(error, templateId, !active));
					return Promise.reject(error);
				},
			);
	};

	function request(templateId, active) {
		return {
			type: agentOfficeSetupConstants.CHANGE_MONTHLY_FEE_TEMPLATE_STATUS_REQUEST,
			templateId,
			active,
		};
	}
	function success() {
		return {
			type: agentOfficeSetupConstants.CHANGE_MONTHLY_FEE_TEMPLATE_STATUS_SUCCESS,
		};
	}
	function failure(error, templateId, active) {
		return {
			type: agentOfficeSetupConstants.CHANGE_MONTHLY_FEE_TEMPLATE_STATUS_ERROR,
			error,
			templateId,
			active,
		};
	}
}
